export default __webpack_public_path__ + "static/media/img_baseBunnyRattle_grey_p.f451d2e6.jpg";